import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m3.465 4.285 6.311 15.327a.75.75 0 0 0 1.224.244l3.447-3.447 3.712 3.713a.752.752 0 0 0 1.061 0l1.06-1.061a.75.75 0 0 0 0-1.061l-3.712-3.712 3.447-3.447a.75.75 0 0 0-.245-1.224L4.444 3.306a.75.75 0 0 0-.979.979Z",
		stroke: "#262626",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		clipRule: "evenodd"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20d%3D%22m3.465%204.285%206.311%2015.327a.75.75%200%200%200%201.224.244l3.447-3.447%203.712%203.713a.752.752%200%200%200%201.061%200l1.06-1.061a.75.75%200%200%200%200-1.061l-3.712-3.712%203.447-3.447a.75.75%200%200%200-.245-1.224L4.444%203.306a.75.75%200%200%200-.979.979Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
